/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SuccessCardTransactionEvidenceListInnerErrors
 */
export interface SuccessCardTransactionEvidenceListInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'detectedDpi'?: SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'calculatedDpi'?: SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'colorGradation'?: SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'heightMillis'?: SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof SuccessCardTransactionEvidenceListInnerErrors
     */
    'widthMillis'?: SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum;
}

export const SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsDetectedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsCalculatedDpiEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsColorGradationEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsHeightMillisEnum];
export const SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum = typeof SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum[keyof typeof SuccessCardTransactionEvidenceListInnerErrorsWidthMillisEnum];


